module.exports = __webpack_public_path__ + "static/media/irish-distillers.8c8f6265.png";